<template>
  <div class="container">
    <div class="mx-auto" style="width: 400px">
      <div class="custom-logo">
        <img
          src="~@/assets/images/Opus_IVS_PoweredBy_Autotechcelerators_256.png"
          alt="App"
          width="256"
        />
      </div>
      <div class="card">
        <h5 class="card-header">Reset Password for App</h5>
        <div class="card-body">
          <ResetPassword :userinfo="userinfo" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ResetPassword from '@/components/auth/ResetPassword.vue'
export default {
  name: 'ResetView',
  components: {
    ResetPassword
  },
  data() {
    return {
      userinfo: null
    }
  },
  mounted() {
    let data = this.$route.query.d
    if (data) {
      var base64 = data.replace(/-/g, '+').replace(/_/g, '/')
      let json = atob(base64)
      this.userinfo = JSON.parse(json)
    }
    console.log('User Info', this.userinfo)
  }
}
</script>
<style lang="scss" scoped>
.custom-logo {
  width: 300px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
